'use strict';

import {reverseUrl} from 'utils/django';

import StateDiagram from 'incidents/utils/states';
import Q from 'incidents/utils/states/query';

var UgWaterStateDiagram = new StateDiagram()
	.add('acknowledged', Q('acknowledged'))
	.add('complainant contacted', Q('contacts:call_completed', 'contacts:call_skipped'))
	.add('preparing to work', Q('geo:at_shop', 'geo:at_shop_skipped'))
	.add('on-scene', Q('geo:arrived'))
	.add('work completed', Q('geo:departed', 'geo:location_skipped'))
	.add('team done', Q('team:done'))
	.add('awaiting approval', Q('form_skipped'))
;


export default function(incident) {
	UgWaterStateDiagram.updateIncident(incident);
	incident.phoneFromUrl = reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});
	incident.problemTypes = [
		{
			code: 'WTR 001',
			display: 'Internal custom request',
			options: [
				'Water Leak',
				'Out of Service Hydrant',
				'New Service',
				'Safety Hazard',
				'New Meter',
				'Move Service',
				'Check Air Relief Valve',
			],
		},
		{
			code: 'WTR 002',
			display: 'External custom request',
			options: [
				'Water Leak - Less than a gallon',
				'Water Leak - A gallon to a pool of water',
				'Water Leak - A moving pool of water',
				'Safety Hazard',
				'Sinkhole',
				'Manhole Cover',
				'Meter Box Cover',
				'Water Infrastructure',
				'Check Meter',
				'Check Valve',
				'Check Hydrant',
			],
		},
	];
}
